import './app';
import './common/commonFns';
import './globals';